import script from "./VNotificationContainer.vue?vue&type=script&setup=true&lang=js"
export * from "./VNotificationContainer.vue?vue&type=script&setup=true&lang=js"

import "./VNotificationContainer.vue?vue&type=style&index=0&id=2bcf0d45&lang=scss"

const __exports__ = script;

export default __exports__